// src/pages/rules/ruleOptions.js
//
// Static option lists and pure helpers for the SOW Rules page -- split out
// of RulesConfigPage.jsx so the page files hold state/handlers/markup only.

export const SOW_RULES_PERMS = ["sow:rules:view", "sow:rules:manage", "sow:rules:manage_global"];
export const PAGE_SIZE = 20;

export const SCOPE_OPTIONS = [
  { value: "", label: "All scopes" },
  { value: "global", label: "Global" },
  { value: "org", label: "Org-wide" },
  { value: "account", label: "Account" },
];

// Built-in contract types; GLOBAL = null/empty
export const BASE_CONTRACT_TYPES = ["T&M", "Fixed Bid", "Managed Services"];

// Suggested categories & dimensions
export const CATEGORY_OPTIONS = [
  "Scope & Deliverables",
  "Scope & Planning",
  "Scope & Risk",
  "Commercials",
  "Quality & Acceptance",
  "Quality & Warranty",
  "Service Levels",
  "Process & Governance",
  "Risk & Legal",
];

export const DIMENSION_OPTIONS = [
  "Scope Clarity",
  "Assumptions & Exclusions",
  "Assumptions & Customer Responsibilities",
  "Milestones & WBS",
  "Acceptance Criteria",
  "Billing & Invoicing",
  "Rate Card & Currency",
  "Change Control",
  "Timesheet & Approval Process",
  "T&E Treatment",
  "Termination & Notice",
  "SLAs & Credits",
  "Risk & Contingency",
  "Exit & Handover",
];

export const SEVERITY_OPTIONS = [
  { value: "low", label: "Low" },
  { value: "medium", label: "Medium" },
  { value: "high", label: "High" },
  { value: "critical", label: "Critical" },
];

export const emptyRule = {
  name: "",
  contract_type: "", // null/empty => GLOBAL
  category: "",
  dimension: "",
  description: "",
  severity: "medium",

  // legacy weight (still stored; auto-calculated by default)
  weight: 1,

  // new factor scoring
  impact: 2,
  likelihood: 2,
  recoverability: 2,
  applicability: 2,
  auto_weight: true,

  is_mandatory: false,
  keyword_pattern: "",
  prompt_hint: "",
  min_score: "",
  max_score: "",
  active: true,
};

export const severityToImpact = (sev) => {
  const s = (sev || "").toLowerCase();
  if (s === "critical") return 4;
  if (s === "high") return 3;
  if (s === "medium") return 2;
  return 1;
};

export const clamp14 = (v, fallback) => {
  const n = Number(v);
  if (!Number.isFinite(n)) return fallback;
  if (n < 1) return 1;
  if (n > 4) return 4;
  return n;
};
